var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('disk-list',{attrs:{"hiddenFilterOptions":['storage', 'region'],"id":_vm.id,"getParams":_vm.getParams,"show-create-action":false}})}
var staticRenderFns = []

export { render, staticRenderFns }